<script setup>
</script>

<template>
  <footer class="footer" role="contentinfo">
    <div class="container">

      <div class="row align-items-center">

        <!-- LOGO -->
        <div class="div_logo col-sm-6">
          <a
            href="https://www.reseau-colibri.fr"
            aria-label="Retour au site principal Réseau Colibri"
          >
            <img
              width="225"
              src="@/assets/logo.png"
              alt="Logo du réseau de transport Réseau Colibri"
            />
          </a>
        </div>

        <!-- LIENS -->
        <div class="col-sm-6 col_right">
          <nav aria-labelledby="footer-links-title">
            <p id="footer-links-title" class="titre_footer">
              Liens utiles
            </p>

            <ul class="liens_footer">
              <li>
                <a
                  href="https://www.reseau-colibri.fr"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Accéder au site Réseau Colibri
                </a>
              </li>

              <li>
                <router-link :to="{ name: 'aide' }">
                  Mode d'emploi
                </router-link>
              </li>
            </ul>

          </nav>
        </div>

      </div>

      <!-- COPYRIGHT -->
      <div id="copyright" class="text-center mt-3">
        <p>
          © 2026 Terres Touloises Mobilité — Tous droits réservés
        </p>
      </div>

    </div>
  </footer>
</template>

<style scoped lang="scss">
@import "@/assets/main";

.footer {
  background-color: $firstcolor;
  color: white;
  margin-top: 3rem;
  padding: 1rem;

  .titre_footer {
    text-transform: uppercase;
    font-family: $titlefont;
    font-weight: 900;
  }

  ul {
    padding: 0;
    list-style-type: none;
  }

  a {
    color: white;
    text-underline-offset: 3px;
  }

  a:hover {
    color: white;
    text-decoration: underline;
  }

  a:focus-visible {
    outline: 3px solid white;
    outline-offset: 2px;
    border-radius: 2px;
  }

  .col_right {
    text-align: right;

    @media (max-width: 575.98px) {
      text-align: left;
      margin-top: 2rem;
    }
  }

  .liens_footer {
    display: grid;
  }

  .div_logo {
    @media (max-width: 575.98px) {
      display: flex;

      a {
        margin: auto;
      }
    }
  }

  #copyright {
    text-align: center;
    margin-top: 2rem;
  }
}
</style>
